import React, { Fragment, ReactElement } from "react";

import { TooltipBody, TooltipHeader, TooltipStyles } from "./Tooltip.styles";
import { useTheme, Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from "@mui/material";

import { Tooltips, TooltipName } from "./TooltipContent";

export interface CustomTooltipProps {
  tooltipName?: TooltipName;
  title?: string;
  content?: string | React.JSX.Element;
  children: ReactElement | string;
  placement?: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top'
}

export const Tooltip = ({
  tooltipName = "generalAdmission",
  placement = "top-end",
  title,
  content,
  children,
  ...rest
}: CustomTooltipProps) => {
  const theme = useTheme();

  let tooltipContent: React.ReactNode = "";

  if (title || content) {
    tooltipContent = (
      <Fragment>
        {title && <TooltipHeader>{title}</TooltipHeader>}
        {content && <TooltipBody>{content}</TooltipBody>}
      </Fragment>
    );
  } else if (tooltipName && Tooltips[tooltipName]) {
    const TooltipContent = Tooltips[tooltipName];
    tooltipContent = TooltipContent();
  }

  return (
    <MuiTooltip
      title={tooltipContent}
      arrow={true}
      placement={placement}
      PopperProps={ { sx: {...TooltipStyles(theme)} }}
      enterTouchDelay={0}
      leaveTouchDelay={600000}
      {...rest}
    >
      <span>
        {children}
      </span>
    </MuiTooltip>
  );
};

export interface TooltipProps extends React.ComponentProps<typeof Tooltip> {
  as?: React.ElementType;
}

Tooltip.displayName = "Tooltip";
